<template>
  <div>
    <!-- <div class="button cta success small import">
      <i class="fa fa-upload"></i>{{ $t('consumer.ratings.export') }}
    </div> -->
    <div class="clearfix"></div>

    <table v-if="!isMobile">
      <thead>
        <th>{{ $t('consumer.ratings.date') }}</th>
        <th>{{ $t('consumer.ratings.rsvpId') }}</th>
        <th>{{ $t('consumer.ratings.provBusinessName') }}</th>
        <th>{{ $t('consumer.ratings.msg') }}</th>
        <th>{{ $t('consumer.ratings.rating') }}</th>
      </thead>
      <tbody>
        <tr v-for="rating in ratings" v-show="ratings.length > 0">
          <td class="date">{{ rating.date }}</td>
          <td class="rsvp">
            <a v-bind:href="'/#/reservation/' + rating.rsvpId">{{ rating.rsvpId }}</a>
          </td>
          <td class="prov">
            <a v-bind:href="'/#/provider/' + rating.provId">{{ rating.provName }}</a>
          </td>
          <td class="message">{{ rating.message }}</td>
          <td class="value">{{ rating.value }}</td>
        </tr>

        <tr v-show="loading">
          <td colspan="5" class="table-block">
              <i class="fa fa-circle-notch fa-spin"></i>
              {{ $t('consumer.ratings.loading') }}
          </td>
        </tr>

        <tr v-show="ratings.length === 0 && !loading">
          <td colspan="5" class="table-block">
            {{ $t('consumer.ratings.emptyState') }}
          </td>
        </tr>
      </tbody>
    </table>

    <div v-else>
      <div v-if="ratings.length > 0">
         <div class="cards" v-for="(rating, i) in ratings" :key="i">
          <div class="card">
            <div class="title card-header">
              <div class="time">{{ rating.date }}</div>
              <div class="rating">{{ rating.value }} <i class="fas fa-star"></i></div>
            </div>
            <div class="title">
              <span class="label">RSVP ID:</span>
              <div class="value"><a v-bind:href="'/#/reservation/' + rating.rsvpId">{{ rating.rsvpId }}</a></div>
            </div>
            <div class="title">
              <span class="label">Provider:</span>
              <div class="value"><a v-bind:href="'/#/provider/' + rating.provId">{{ rating.provName }}</a></div>
            </div>
            <div class="title">
              <span class="label">Message:</span>
              <div class="value">
                {{ rating.message ? rating.message : '--' }}
              </div>
            </div>
          </div>
         </div>
      </div>
      <div v-else>{{ $t('consumer.ratings.emptyState') }}</div>
    </div>
  </div>
</template>

<script>
import ApiRatings from '../../modules/api/consumer/ratings'

export default {
  name: 'ratings',
  props: ['conId', 'isMobile'],
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ratings () {
      return this.$store.state.consumer.ratings.list
    },
    isMax () {
      return this.$store.state.consumer.ratings.isMax
    }
  },
  methods: {
    init () {
      this.$store.commit('consumer/resetRatings')
      this.$store.commit('consumer/setRatingsIsMax', false)
      this.$store.commit('consumer/setRatingsCurrentPage', 0)
      this.getRatings()
    },
    getRatings () {
      let self = this
      if (self.isMax || self.loading) { return }

      self.loading = true
      ApiRatings.getRatings(self, self.conId, function () {
        self.loading = false
      })
    }
  },
  watch: {
    conId: function (value) {
      this.init()
    },
    isMobile: function (value) {
      this.init()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.import{
  float: right;
  .fa{ margin-right: 5px; }
}

.clearfix{ clear: both; }

table{
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;

  thead{
    color: #8DA0A9;
    font-size: 12px;
    border: 1px solid rgba(0,0,0,0.3);
    background-color: #f5f5f5;

    th{ padding: 5px 10px; }
  }

  tbody{
    tr{
      background-color: #fff;
      border: 1px solid rgba(0,0,0,0.3);

      td{
        padding: 10px;
        text-align: center;
        font-size: 12px;
        margin-bottom: 5px;

        &.date, &.value{ width: 160px; }
        &.table-block{
          padding: 30px;
          font-size: 24px;
          color: #777;
          font-weight: 600;
          font-style: italic;

          .fa{
            color: #ccc;
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 430px) {
  .cards {
    .card {
      border: 1px solid #ccc;
      margin-bottom: 15px;
      padding: 8px;
      padding-bottom: 3px;
      border-bottom: 5px solid #aaa9;
      border-radius: 10px;

      > div {
        margin-bottom: 3px;
      }

      .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
        .time {
          font-size: 12px;
          color: #777;
          word-spacing: 5px;
        }

        .rating {
          font-weight: 900;
          font-size: 20px;
          i {
            color: gold;
          }
        }
      }

      .title {
        display: flex;
        align-items: center;
        .rsvpId {
          font-weight: 900;
          margin-right: 10px;
        }
      }


      .label {
        font-size: 12px;
        text-transform: uppercase;
        color: #bbb;
        font-weight: 600;
        margin-right: 5px;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Consumer/Ratings.vue